import request from './base'
export const triggerList = (params) => {
    return request.post("/admin/v1/trigger/list", params)
}


// WEBPACK FOOTER //
// ./src/api/triggers.js